"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SocialModule = _interopRequireDefault(require("./Social.module.css"));

var staticImages = _interopRequireWildcard(require("../staticImages"));

var _grommet = require("grommet");

var _SocialBlock = _interopRequireDefault(require("./SocialBlock"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// function MapLinks ({links}) {
//     for(let i = 0; i < Math.ceil(links.length/3); i++ ) {
//         return (
//             <div id = {styles.test_box1}></div>
//         )
//     }
// }
var Stats = /*#__PURE__*/function (_React$Component) {
  _inherits(Stats, _React$Component);

  var _super = _createSuper(Stats);

  function Stats(props) {
    var _this;

    _classCallCheck(this, Stats);

    _this = _super.call(this, props);
    _this.state = {
      socialLinks: [{
        name: "Facebook",
        img: staticImages.FACEBOOK,
        color: false,
        link: null
      }, {
        name: "Instagram",
        img: staticImages.INSTAGRAM,
        color: false,
        link: null
      }, {
        name: "LinkedIn",
        img: staticImages.LINKEDIN,
        color: '#0e76a8',
        link: null
      }, {
        name: "Twitter",
        img: staticImages.TWITTER,
        color: "#1DA1F2",
        link: null
      }, {
        name: "Website",
        img: staticImages.WEBSITE,
        color: '#5BE7C3',
        link: null
      }, {
        name: "Calendar",
        img: staticImages.CALENDAR,
        color: '#827482',
        link: null
      }, {
        name: "Application",
        img: staticImages.APPLICATION,
        color: '#5ACEF2',
        link: null
      }, {
        name: "External",
        img: staticImages.EXTERNAL,
        color: "#3AB575",
        link: null
      }],
      social_links: [],
      printArray: []
    };
    _this.generateArray = _this.generateArray.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Stats, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.info.socialLinks.Application) {
        this.state.socialLinks[6].link = this.props.info.socialLinks.Application;
        this.state.social_links.push(this.state.socialLinks[6]);
      }

      if (this.props.info.socialLinks.Website) {
        this.state.socialLinks[4].link = this.props.info.socialLinks.Website;
        this.state.social_links.push(this.state.socialLinks[4]);
      }

      if (this.props.info.socialLinks.Calendar) {
        this.state.socialLinks[5].link = this.props.info.socialLinks.Calendar;
        this.state.social_links.push(this.state.socialLinks[5]);
      }

      if (this.props.info.socialLinks.Instagram) {
        this.state.socialLinks[1].link = this.props.info.socialLinks.Instagram;
        this.state.social_links.push(this.state.socialLinks[1]);
      }

      if (this.props.info.socialLinks.Facebook) {
        this.state.socialLinks[0].link = this.props.info.socialLinks.Facebook;
        this.state.social_links.push(this.state.socialLinks[0]);
      }

      if (this.props.info.socialLinks.LinkedIn) {
        this.state.socialLinks[2].link = this.props.info.socialLinks.LinkedIn;
        this.state.social_links.push(this.state.socialLinks[2]);
      }

      if (this.props.info.socialLinks.Twitter) {
        this.state.socialLinks[3].link = this.props.info.socialLinks.Twitter;
        this.state.social_links.push(this.state.socialLinks[3]);
      }

      if (this.props.info.socialLinks.External) {
        this.state.socialLinks[7].link = this.props.info.socialLinks.External;
        this.state.social_links.push(this.state.socialLinks[7]);
      }

      if (window.innerWidth < 767 && window.innerWidth > 600) {
        this.generateArray(5);
      } else {
        this.generateArray(3);
      }
    }
  }, {
    key: "switch",
    value: function _switch() {
      if (window.innerWidth <= 450 && this.state.num !== 2) {
        this.generateArray(2);
      } else if (window.innerWidth > 450 && window.innerWidth <= 570 && this.state.num !== 3) {
        this.generateArray(3);
      } else if (window.innerWidth > 570 && window.innerWidth <= 690 && this.state.num !== 4) {
        this.generateArray(4);
      } else if (window.innerWidth > 690 && window.innerWidth <= 767 && this.state.num !== 5) {
        this.generateArray(5);
      }
    }
  }, {
    key: "generateArray",
    value: function generateArray(num) {
      var length = this.state.social_links.length;

      if (num === 3) {
        for (var j = 0; j < length; j += num) {
          var block1;

          if (j + num - 1 < length) {
            block1 = /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                zIndex: 10
              }
            }, /*#__PURE__*/_react["default"].createElement(_SocialBlock["default"], {
              link: this.state.social_links[j].link,
              img: this.state.social_links[j].img,
              name: this.state.social_links[j].name,
              color: this.state.social_links[j].color,
              left: "".concat(j % 3 * 30.5 + 12.65, "%")
            }), /*#__PURE__*/_react["default"].createElement(_SocialBlock["default"], {
              link: this.state.social_links[j + 1].link,
              img: this.state.social_links[j + 1].img,
              name: this.state.social_links[j + 1].name,
              color: this.state.social_links[j + 1].color,
              left: "".concat((j % 3 + 1) * 30.5 + 12.65, "%")
            }), /*#__PURE__*/_react["default"].createElement(_SocialBlock["default"], {
              link: this.state.social_links[j + 2].link,
              img: this.state.social_links[j + 2].img,
              name: this.state.social_links[j + 2].name,
              color: this.state.social_links[j + 2].color,
              left: "".concat((j % 3 + 2) * 30.5 + 12.65, "%")
            }));
          } else if (j + num - 1 === length) {
            block1 = /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                zIndex: 10
              }
            }, /*#__PURE__*/_react["default"].createElement(_SocialBlock["default"], {
              link: this.state.social_links[j].link,
              img: this.state.social_links[j].img,
              name: this.state.social_links[j].name,
              color: this.state.social_links[j].color,
              left: "".concat(j % 3 * 30.5 + 12.65, "%")
            }), /*#__PURE__*/_react["default"].createElement(_SocialBlock["default"], {
              link: this.state.social_links[j + 1].link,
              img: this.state.social_links[j + 1].img,
              name: this.state.social_links[j + 1].name,
              color: this.state.social_links[j + 1].color,
              left: "".concat((j % 3 + 1) * 30.5 + 12.65, "%")
            }));
          } else if (j + num - 2 === length) {
            block1 = /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                zIndex: 10
              }
            }, /*#__PURE__*/_react["default"].createElement(_SocialBlock["default"], {
              link: this.state.social_links[j].link,
              img: this.state.social_links[j].img,
              name: this.state.social_links[j].name,
              color: this.state.social_links[j].color,
              left: "".concat(j % 3 * 30.5 + 12.65, "%")
            }));
          }

          this.state.printArray.push(block1);
        }
      } else if (num === 5) {
        for (var i = 0; i < length; i += num) {
          var block;

          if (i + num - 1 < length) {
            block = /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                zIndex: 10
              }
            }, /*#__PURE__*/_react["default"].createElement(_SocialBlock["default"], {
              link: this.state.social_links[i].link,
              img: this.state.social_links[i].img,
              name: this.state.social_links[i].name,
              color: this.state.social_links[i].color,
              left: "".concat(i % 5 * 18.5 + 8, "%")
            }), /*#__PURE__*/_react["default"].createElement(_SocialBlock["default"], {
              link: this.state.social_links[i + 1].link,
              img: this.state.social_links[i + 1].img,
              name: this.state.social_links[i + 1].name,
              color: this.state.social_links[i + 1].color,
              left: "".concat((i % 5 + 1) * 18.5 + 8, "%")
            }), /*#__PURE__*/_react["default"].createElement(_SocialBlock["default"], {
              link: this.state.social_links[i + 2].link,
              img: this.state.social_links[i + 2].img,
              name: this.state.social_links[i + 2].name,
              color: this.state.social_links[i + 2].color,
              left: "".concat((i % 5 + 2) * 18.5 + 8, "%")
            }), /*#__PURE__*/_react["default"].createElement(_SocialBlock["default"], {
              link: this.state.social_links[i + 3].link,
              img: this.state.social_links[i + 3].img,
              name: this.state.social_links[i + 3].name,
              color: this.state.social_links[i + 3].color,
              left: "".concat((i % 5 + 3) * 18.5 + 8, "%")
            }), /*#__PURE__*/_react["default"].createElement(_SocialBlock["default"], {
              link: this.state.social_links[i + 4].link,
              img: this.state.social_links[i + 4].img,
              name: this.state.social_links[i + 4].name,
              color: this.state.social_links[i + 4].color,
              left: "".concat((i % 5 + 4) * 18.5 + 8, "%")
            }));
          } else if (i + num - 1 === length) {
            block = /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                zIndex: 10
              }
            }, /*#__PURE__*/_react["default"].createElement(_SocialBlock["default"], {
              link: this.state.social_links[i].link,
              img: this.state.social_links[i].img,
              name: this.state.social_links[i].name,
              color: this.state.social_links[i].color,
              left: "".concat(i % 5 * 18.5 + 8, "%")
            }), /*#__PURE__*/_react["default"].createElement(_SocialBlock["default"], {
              link: this.state.social_links[i + 1].link,
              img: this.state.social_links[i + 1].img,
              name: this.state.social_links[i + 1].name,
              color: this.state.social_links[i + 1].color,
              left: "".concat((i % 5 + 1) * 18.5 + 8, "%")
            }), /*#__PURE__*/_react["default"].createElement(_SocialBlock["default"], {
              link: this.state.social_links[i + 2].link,
              img: this.state.social_links[i + 2].img,
              name: this.state.social_links[i + 2].name,
              color: this.state.social_links[i + 2].color,
              left: "".concat((i % 5 + 2) * 18.5 + 8, "%")
            }), /*#__PURE__*/_react["default"].createElement(_SocialBlock["default"], {
              link: this.state.social_links[i + 3].link,
              img: this.state.social_links[i + 3].img,
              name: this.state.social_links[i + 3].name,
              color: this.state.social_links[i + 3].color,
              left: "".concat((i % 5 + 3) * 18.5 + 8, "%")
            }));
          } else if (i + num - 2 === length) {
            block = /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                zIndex: 10
              }
            }, /*#__PURE__*/_react["default"].createElement(_SocialBlock["default"], {
              link: this.state.social_links[i].link,
              img: this.state.social_links[i].img,
              name: this.state.social_links[i].name,
              color: this.state.social_links[i].color,
              left: "".concat(i % 5 * 18.5 + 8, "%")
            }), /*#__PURE__*/_react["default"].createElement(_SocialBlock["default"], {
              link: this.state.social_links[i + 1].link,
              img: this.state.social_links[i + 1].img,
              name: this.state.social_links[i + 1].name,
              color: this.state.social_links[i + 1].color,
              left: "".concat((i % 5 + 1) * 18.5 + 8, "%")
            }), /*#__PURE__*/_react["default"].createElement(_SocialBlock["default"], {
              link: this.state.social_links[i + 2].link,
              img: this.state.social_links[i + 2].img,
              name: this.state.social_links[i + 2].name,
              color: this.state.social_links[i + 2].color,
              left: "".concat((i % 5 + 2) * 18.5 + 8, "%")
            }));
          } else if (i + num - 3 === length) {
            block = /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                zIndex: 10
              }
            }, /*#__PURE__*/_react["default"].createElement(_SocialBlock["default"], {
              link: this.state.social_links[i].link,
              img: this.state.social_links[i].img,
              name: this.state.social_links[i].name,
              color: this.state.social_links[i].color,
              left: "".concat(i % 5 * 18.5 + 8, "%")
            }), /*#__PURE__*/_react["default"].createElement(_SocialBlock["default"], {
              link: this.state.social_links[i + 1].link,
              img: this.state.social_links[i + 1].img,
              name: this.state.social_links[i + 1].name,
              color: this.state.social_links[i + 1].color,
              left: "".concat((i % 5 + 1) * 18.5 + 8, "%")
            }));
          } else if (i + num - 4 === length) {
            block = /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                zIndex: 10
              }
            }, /*#__PURE__*/_react["default"].createElement(_SocialBlock["default"], {
              link: this.state.social_links[i].link,
              img: this.state.social_links[i].img,
              name: this.state.social_links[i].name,
              color: this.state.social_links[i].color,
              left: "".concat(i % 5 * 18.5 + 8, "%")
            }));
          }

          this.state.printArray.push(block);
        }
      }

      this.forceUpdate();
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.printArray.length === 0) {
        return /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
          id: _SocialModule["default"].outer_div
        }, /*#__PURE__*/_react["default"].createElement("div", {
          id: _SocialModule["default"].noLinks
        }, "No Social Links"));
      } else {
        return (
          /*#__PURE__*/
          // <div id={styles.outer_div}>
          _react["default"].createElement(_grommet.Box, {
            id: _SocialModule["default"].outer_div
          }, /*#__PURE__*/_react["default"].createElement(_grommet.Carousel, {
            fill: true,
            controls: "arrows"
          }, this.state.printArray.map(function (item, index) {
            return /*#__PURE__*/_react["default"].createElement("div", {
              key: index
            }, item);
          }))) // </div>

        );
      }
    }
  }]);

  return Stats;
}(_react["default"].Component);

var _default = Stats;
exports["default"] = _default;

//# sourceMappingURL=Social.js.map